import { ThemeDefault } from '@seddi/ui-kit';
const decoratorPrimary = 'rgb(50, 147, 111)';
const decoratorSecondary = 'rgb(103, 203, 166)';
const color = Object.assign(Object.assign({}, ThemeDefault.color), { s1: decoratorPrimary, s2: decoratorSecondary });
export const ThemeApp = Object.assign(Object.assign({}, ThemeDefault), { color });
